var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"contentview"},[_c('p'),_c('p'),_c('span',{domProps:{"innerHTML":_vm._s(_vm.HTMLcontent)}}),_c('p'),_c('p')])
}
var staticRenderFns = []

export { render, staticRenderFns }